export enum ECaseViews {
  CHAT = "chat",
  DOSSIER = "dossier",
  ACTIONS = "actions",
  LETTERS = "letters",
  PACKAGES = "packages",
  LETTER = "letter",
  PARTIAL = "partial",
  TASKS = "tasks",
  LIST = "list",
  NOTES = "notes",
  ACTION_DAY = "actions_day",
  ACTION_WEEK = "actions_week",
  ACTION_MONTH = "actions_month",
  COURTPORTAL = "court_portal",
}
